import React, {useCallback, useRef} from 'react';
import cn from 'classnames';

import {EEventType} from 'coreClasses/events/IEvents';
import {getIsInternalUrl} from 'coreUtils/url';

import {useHeaderCtx} from 'brandComponents/Header/HeaderCtx';
import Link from 'brandComponents/Link';
import {usePromotionViewEvent} from 'brandHooks/usePromotionViewEvent';
import {useTrackPromotionEvent} from 'brandHooks/useTrackPromotionEvent';

import {IFlatNavigationLinkProps} from './IFlatNavigationLink';

const FlatNavigationLink = (
	{
		description,
		url,
		title,
		color,
		queryParameters,
		classNames = '',
		image,
	}: IFlatNavigationLinkProps) => {
	const elementRef = useRef(null);
	const {trackPromotionEvent} = useTrackPromotionEvent();
	const headerCtx = useHeaderCtx(true);
	const isInternalUrl = getIsInternalUrl(url);
	const urlWithQueryParams = queryParameters ? `${url}?${queryParameters}` : url;

	usePromotionViewEvent(elementRef, urlWithQueryParams);

	const handleClick = useCallback(() => {
		if (headerCtx) {
			headerCtx.handleNavigationVisibility();
		}

		if (queryParameters) {
			trackPromotionEvent(urlWithQueryParams, EEventType.SELECT_BRAND_PROMOTION);
		}
	}, [headerCtx, queryParameters, trackPromotionEvent, urlWithQueryParams, EEventType]);

	const content = (
		<>
			{image}
			<span className="navigation-item-content__title">{title}</span>
			{!!description && <span>{description}</span>}
		</>
	);

	if (!isInternalUrl) {
		return (
			<a
				href={url}
				className={classNames}
				style={{color}}
				rel="noopener noreferrer"
			>
				{content}
			</a>
		);
	}

	const to = queryParameters ? `${url}?${queryParameters}` : url;

	return (
		<Link
			to={to}
			style={{color}}
			className={cn({'nav-link-with-description': description}, classNames)}
			ref={elementRef}
			onClick={handleClick}
		>
			{content}
		</Link>
	);
};

export default FlatNavigationLink;
